/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { type CommonProps } from '../_common/types';

export type TrailProps = {
  variant: 'straight' | 'curved' | 'straight-curved' | 'none';
};
export const Trail = ({
  variant,
  htmlAttributes,
  ...restProps
}: CommonProps<'div', TrailProps>) => {
  return (
    <div className="ndl-trail" {...restProps} {...htmlAttributes}>
      {variant === 'straight' && (
        <svg
          className="ndl-trail-straight"
          aria-hidden={true}
          width="2"
          height="24"
          viewBox="0 0 2 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1.00001 16.0005L1 -4.00049L1 28.0004" stroke="#BBBEC3" />
        </svg>
      )}
      {variant === 'curved' && (
        <svg
          aria-hidden={true}
          className="ndl-trail-curved"
          width="9"
          height="13"
          viewBox="0 0 9 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 -4L1 3.99988C1 8.41816 4.58172 11.9999 9 11.9999V11.9999"
            stroke="#BBBEC3"
          />
        </svg>
      )}
      {variant === 'straight-curved' && (
        <svg
          aria-hidden={true}
          className="ndl-trail-straight-curved"
          width="16"
          height="24"
          viewBox="0 0 16 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_16990_133)">
            <path
              d="M16 12V12C11.5817 12 8.00001 8.41828 8.00001 4L8.00001 -4L8 28"
              stroke="#BBBEC3"
            />
          </g>
          <defs>
            <clipPath id="clip0_16990_133">
              <rect width="16" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </div>
  );
};
